import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { modeFavicon } from '../../mode-nevek';
import { GepjarmuService } from '../gepjarmu.service';

/*  GÉPJÁRMŰ – kezdőlap: a képernyők csempéi, a cég összesítője (aktív járművek, sofőrök, e havi km jelleg
 *  szerint, idei költség) és a lejáró / lejárt okmányok, biztosítások (backend: GET /attekintes). */
@Component({
  selector: 'app-gj-kezdolap',
  templateUrl: './kezdolap.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../../szamlazo/kezdolap/kezdolap.component.scss', '../gepjarmu-shared.scss'],
})
export class GjKezdolapComponent implements OnInit, OnDestroy {
  ikon = modeFavicon('GEPJARMU');
  readonly csempek = [
    { cim: 'Járművek', leiras: 'Járműtörzs, norma, óraállások, tárgyi eszköz, a cégautóadó adatai', ikon: 'car-outline', ut: '/gepjarmu/jarmuvek' },
    { cim: 'Útnyilvántartás', leiras: 'Utak rögzítése, havi tervező, km-óra', ikon: 'map-outline', ut: '/gepjarmu/utnyilvantartas' },
    { cim: 'Elszámolás', leiras: 'Üzemanyag-elszámolás normával, NAV-árral; magánhasználat', ikon: 'calculator-outline', ut: '/gepjarmu/elszamolas' },
    { cim: 'Kiküldetés', leiras: 'Kiküldetési rendelvény, költségtérítés, átadás a Bérbe', ikon: 'document-text-outline', ut: '/gepjarmu/kikuldetes' },
    { cim: 'Költségek és lejáratok', leiras: 'Tankolás, szerviz, biztosítás; műszaki vizsga, KGFB, matrica', ikon: 'receipt-outline', ut: '/gepjarmu/koltsegek' },
    { cim: 'Cégautóadó', leiras: 'Havi adó járművenként, 2601-es bevallás, feladás a Könyvelésbe', ikon: 'cash-outline', ut: '/gepjarmu/cegautoado' },
    { cim: 'Sofőrök', leiras: 'Sofőrök, szabadnapok, kötés a Bér dolgozójához', ikon: 'person-outline', ut: '/gepjarmu/soforok' },
    { cim: 'Címtár', leiras: 'Telephelyek, partnerek (a Könyvelésből is), távolságok', ikon: 'location-outline', ut: '/gepjarmu/cimtar' },
    { cim: 'Beállítások', leiras: 'Normaköltség, korrekciók, NAV üzemanyagárak, ügyfélkör', ikon: 'settings-outline', ut: '/gepjarmu/beallitasok' },
  ];
  ossz: any = null;
  hiba = '';
  private sub?: Subscription;
  constructor(public gj: GepjarmuService, private router: Router) {}
  async ngOnInit() { await this.gj.init(); this.sub = this.gj.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    const u = this.gj.aktiv.ugyfelId;
    this.hiba = '';
    if (!u) { this.ossz = null; return; }
    try { this.ossz = await this.gj.get(`/attekintes/${u}?ev=${this.gj.aktiv.ev}`); }
    catch (e: any) { this.ossz = null; this.hiba = e?.error?.error || 'Nem sikerült betölteni az áttekintést.'; }
  }
  nyit(ut: string, query?: any) { this.router.navigate([ut], { queryParams: query }); }
  get honapNev(): string {
    const h = this.ossz?.honap;
    return h ? new Date(h.ev, h.ho - 1, 1).toLocaleDateString('hu-HU', { month: 'long' }) : '';
  }
  szam(v: number, t = 0) { return Number(v || 0).toLocaleString('hu-HU', { maximumFractionDigits: t }); }
  hatra(e: any): string {
    if (e.hatra_nap == null) return '';
    if (e.hatra_nap < 0) return `${-e.hatra_nap} napja lejárt`;
    if (e.hatra_nap === 0) return 'ma jár le';
    return `${e.hatra_nap} nap múlva`;
  }
}
